import { createAction } from '@reduxjs/toolkit';

import { VideoPlayerState } from './reducer';

export const PLAY_VIDEO = 'Teamleader/VideoPlayer/PLAY_VIDEO';
export const CLOSE_VIDEO = 'Teamleader/VideoPlayer/CLOSE_VIDEO';

export const playVideo = createAction<VideoPlayerState>(PLAY_VIDEO);
export const closeVideo = createAction(CLOSE_VIDEO);
